import Container from '@/components/container'
import AppContent from '@/components/content'
import DefinitionLoader from '@/components/content/definitionLoader'
import Searcher from '@/components/content/searcher'
import FormBuilder from '@/components/content/formBuilder'
import SegmentBuilder from '@/components/content/segmentBuilder'
import SegmentDashboard from '@/components/content/segmentBuilder/dashboard'
import GraficsDashboard from '@/components/content/graficsDashboard'
import { router } from '@/router'

export default {
  methods: {
    getDefaultCurrentContent (menu) {
      var currentContent = null
      if (menu) {
        menu.map((item) => {
          var defaultFound = false
          if (item.default) {
            currentContent = item
            defaultFound = true
          }
          if (defaultFound && item.subMenu) {
            var childCurrentContent = this.getDefaultCurrentContent(item.subMenu)
            if (childCurrentContent) {
              currentContent = childCurrentContent
            }
          }
        })
        if (!currentContent) {
          currentContent = this.getDefaultCurrentContent(menu[0].subMenu)
        }
      }
      return currentContent
    },
    getContent (menu, contextPath, path, parent) {
      var content = {
        currentContent: null,
        detailContent: null,
        detailContentId: null
      }
      if (menu) {
        for (var i = 0; i < menu.length && content.currentContent === null; i++) {
          var menuUrl = menu[i].parentContextPath + menu[i].contextPath
          var menuUrlParams = menuUrl.split('/')

          if (path.startsWith(contextPath)) {
            path = path.slice(contextPath.length - 1)
          }
          var pathParams = path.split('/')

          var found = true
          var detailContentId = null
          if (menuUrlParams.length !== pathParams.length) {
            found = false
          } else {
            for (var j = 0; j < menuUrlParams.length && found; j++) {
              if (menuUrlParams[j] !== pathParams[j] && menuUrlParams[j].substr(0, 3) !== ':id') {
                found = false
              } else if (menuUrlParams[j].substr(0, 3) === ':id') {
                detailContentId = pathParams[j]
              }
            }
          }

          if (found) {
            // Detail content, load level 3 content as main level
            if (menuUrlParams.length > 4) {
              content.currentContent = parent
              content.detailContent = menu[i]
              content.detailContentId = detailContentId
            } else {
              content.currentContent = menu[i]
            }
          } else {
            if (content.currentContent === null && menu[i].subMenu) {
              var childContent = this.getContent(menu[i].subMenu, contextPath, path, menu[i])
              if (childContent.currentContent) {
                content = childContent
              }
            }
          }
        }
      }
      return content
    },
    getDefaultParentMenuPath (parent, menu, path) {
      var menuParent = null

      if (menu) {
        for (var i = 0; i < menu.length && menuParent === null; i++) {
          var menuItem = menu[i]
          var menuUrl = menuItem.parentContextPath + menuItem.contextPath
          if (menuUrl === path) {
            // first search for search
            if ((menuItem.type.id === 'definition' || menuItem.type.id === 'template') && menuItem.type.modeView === 'new') {
              var menuEndName = menuItem.id.substr(menuItem.id.indexOf('-') + 1)
              for (var j = 0; j < menu.length && menuParent === null; j++) {
                var aux = menu[j]
                if (aux.type.id === 'search' && aux.id.substr(aux.id.indexOf('-') + 1) === menuEndName) {
                  menuParent = aux
                }
              }
              if (menuParent === null) {
                menuParent = this.getDefaultParentMenuPath(menuItem, menuItem.subMenu, path)
              }
            } else {
              menuParent = parent
            }
          } else if (menuItem.subMenu) {
            menuParent = this.getDefaultParentMenuPath(menuItem, menuItem.subMenu, path)
          }
        }
      }

      return menuParent
    },
    getMenuAppRoutes (menu) {
      var menuRoutes = null
      if (menu != null) {
        menuRoutes = []
        menu.map((item) => {
          var type = item.type

          let route = {
            path: item.contextPath,
            name: item.id,
            props: item,
            children: this.getMenuAppRoutes(item.subMenu)
          }

          if (type) {
            if (type.id === 'definition' || type.id === 'template' || type.id === 'workflow' || type.id === 'tree') {
              route.component = DefinitionLoader
            } else if (type.id === 'search') {
              route.component = Searcher
            } else if (type.id === 'content') {
              route.component = AppContent
            } else if (type.id === 'form-builder') {
              route.component = FormBuilder
            } else if (type.id === 'segment-builder') {
              route.component = SegmentBuilder
            } else if (type.id === 'segment-dashboard') {
              route.component = SegmentDashboard
            } else if (type.id === 'grafics-dashboard') {
              route.component = GraficsDashboard
            } else {
              route.component = Container
            }
          } else if (item.contextPath) {
            route.component = Container
          }

          menuRoutes.push(route)
        })
      }
      return menuRoutes
    },
    loadDetailView (detailMenuId, detailIdValue, detailCodeValue) {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden'

      if (detailIdValue && detailIdValue !== '') {
        var pushObj = {
          name: detailMenuId,
          params: { id: detailIdValue }
        }
        if (detailCodeValue && detailCodeValue !== '') {
          pushObj.query = { code: detailCodeValue }
        }
        router.push(pushObj).catch(() => {})
      }
    },
    getNewMenuOfSearcherOption (menu, searcherMenuId) {
      var result = null
      var searcherMenuLevel = this.getMenuLevel(menu, searcherMenuId)
      if (searcherMenuLevel) {
        var newMenuId = 'new-' + searcherMenuId.substr(searcherMenuId.indexOf('search-') + 7)
        var newMenu = null
        var found = false
        for (var i = 0; i < searcherMenuLevel.length && !found; i++) {
          var menuOption = searcherMenuLevel[i]
          if (newMenuId === menuOption.id) {
            found = true
            // check create action or external new path
            if (
              (!menuOption.type && menuOption.contextPath) || (menuOption.type && menuOption.type.actions && menuOption.type.actions.create)
            ) {
              newMenu = menuOption
            }
          }
        }
        result = newMenu
      }
      return result
    },
    getSearcherMenuOfNewOption (menu, newMenuId) {
      var result = null
      var newMenuLevel = this.getMenuLevel(menu, newMenuId)
      if (newMenuLevel) {
        var searcherMenuId = 'search-' + newMenuId.substr(newMenuId.indexOf('new-') + 4)
        var searcherMenu = null
        for (var i = 0; i < newMenuLevel.length && !searcherMenu; i++) {
          if (searcherMenuId === newMenuLevel[i].id) {
            searcherMenu = newMenuLevel[i]
          }
        }
        result = searcherMenu
      }
      return result
    },
    getMenuLevel (menu, menuId) {
      var result = null
      if (menu) {
        for (var i = 0; i < menu.length && !result; i++) {
          if (menu[i].id === menuId) {
            result = menu
          } else {
            result = this.getMenuLevel(menu[i].subMenu, menuId)
          }
        }
      }
      return result
    }
  }
}
